import { ServiceDefinition } from '@pershing/pershing-core';

export class PositonsTradingServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    // TODO - check this name and make sure it is correct
    uri: string = 'positions';
    version: string = 'v1';
    
    appName: string = 'netx360-positions-svc'; 
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!PositonsTradingServiceDefinition.instance) {
            PositonsTradingServiceDefinition.instance = new PositonsTradingServiceDefinition();
            if (platform === 'retail') {
                PositonsTradingServiceDefinition.instance.appName = 'netxinvestor-positions-svc';
                PositonsTradingServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return PositonsTradingServiceDefinition.instance;
    }


    private constructor() {
        //intentional empty constructor
    }
}
